import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Mail, CreditCard } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="comprar" className="bg-light text-text-light py-20 md:py-28 px-6" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-accent p-8 md:p-16 text-center relative overflow-hidden" data-id="element-101">
          {/* Top accent bar */}
          <div className="absolute top-0 left-0 right-0 h-2 bg-accent" data-id="element-102"></div>

          <h2 className="text-3xl md:text-4xl font-serif text-dark-100 mb-6" data-id="element-103">
            Recupera tu salud mental, tu energía y el descanso de tu bebé hoy
            mismo
          </h2>

          <p className="text-xl text-text-light/70 mb-12" data-id="element-104">
            Por una fracción de lo que cuesta una consultora de sueño privada.
          </p>

          <div className="mb-12" data-id="element-105">
            <span className="block text-sm uppercase tracking-widest text-accent font-bold mb-2" data-id="element-106">
              Acceso inmediato por solo
            </span>
            <div className="flex items-center justify-center" data-id="element-107">
              <span className="text-6xl md:text-7xl font-serif font-bold text-dark-100" data-id="element-108">
                $6.50
              </span>
              <span className="text-2xl text-dark-100/60 ml-2 mt-4" data-id="element-109">USD</span>
            </div>
          </div>

          <motion.a href="https://movilidadserena.com/cart/47349111030013:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto bg-accent text-dark-100 font-bold text-xl md:text-2xl px-10 py-5 rounded-xl shadow-[0_0_30px_rgba(212,165,116,0.4)] hover:shadow-[0_0_50px_rgba(212,165,116,0.6)] transition-all duration-300 mb-8" data-id="element-110">
            Quiero que mi bebé y yo durmamos hoy
          </motion.a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-text-light/60" data-id="element-111">
            <div className="flex items-center" data-id="element-112">
              <ShieldCheck className="w-5 h-5 mr-2 text-green-600" data-id="element-113" />
              <span data-id="element-114">Pago 100% seguro</span>
            </div>
            <div className="flex items-center" data-id="element-115">
              <Mail className="w-5 h-5 mr-2 text-accent" data-id="element-116" />
              <span data-id="element-117">Entrega inmediata</span>
            </div>
            <div className="flex items-center" data-id="element-118">
              <CreditCard className="w-5 h-5 mr-2 text-dark-200" data-id="element-119" />
              <span data-id="element-120">Tarjetas / PayPal</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}